import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { queries } from '~extension/web2print/controller/api/Queries';
import { Job } from '~extension/web2print/model/Job';
import { SapParameters } from '~extension/web2print/model/SapParameters';
import { MissingHookMessage } from '~extension/web2print/view/SapExport/MissingHookMessage';
import { OrderForm } from '~extension/web2print/view/SapExport/OrderForm';

type SapExportDetailControllerProps = {
  job: Job;
};

export function SapExportDetailController({ job }: SapExportDetailControllerProps) {
  const [sapParameters, setSapParameters] = useState<SapParameters>(undefined);
  const [sapDownloadUrl, setSapDownloadUrl] = useState<string>(undefined);
  const [error, setError] = useState<boolean>(undefined);

  useEffect(() => {
    setSapParameters(undefined);
    setSapDownloadUrl(undefined);
    setError(undefined);
  }, [job]);

  // get parameters
  const { data: sapParametersData, isError: sapParametersError } = useQuery({
    ...queries.web2print.getSapParameters(),
    enabled: !Boolean(error) && Boolean(job) && !Boolean(sapParameters),
  });
  useEffect(() => {
    if (sapParametersData !== undefined) setSapParameters(sapParametersData);
  }, [sapParametersData]);

  // get download url
  const { data: downloadUrlData, isError: downloadUrlError } = useQuery({
    ...queries.web2print.getSapDownloadUrl(job.documentId, job.clientId),
    enabled: !Boolean(error) && Boolean(sapParameters) && sapParameters.hasValidHookUrl,
  });
  useEffect(() => {
    if (downloadUrlData !== undefined) setSapDownloadUrl(downloadUrlData.url);
  }, [downloadUrlData]);

  useEffect(() => {
    if (sapParametersError || downloadUrlError) {
      setError(true);
    }
  }, [sapParametersError, downloadUrlError]);

  if (!Boolean(sapParameters)) return null;

  if (sapParameters.hasValidHookUrl === true)
    return <OrderForm job={job} hookUrl={sapParameters.hookUrl} orderMessage={sapDownloadUrl} />;
  else return <MissingHookMessage loginUrl={sapParameters.loginUrl} />;
}
